import { render, staticRenderFns } from "./VideoPromo.vue?vue&type=template&id=16e8efea&scoped=true"
import script from "./VideoPromo.vue?vue&type=script&lang=js"
export * from "./VideoPromo.vue?vue&type=script&lang=js"
import style0 from "./VideoPromo.vue?vue&type=style&index=0&id=16e8efea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8efea",
  null
  
)

export default component.exports